import { render, staticRenderFns } from "./ChatSingleMessage.vue?vue&type=template&id=7833792e&scoped=true"
import script from "./ChatSingleMessage.vue?vue&type=script&lang=js"
export * from "./ChatSingleMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatSingleMessage.vue?vue&type=style&index=0&id=7833792e&prod&lang=scss&scoped=true"
import style1 from "./ChatSingleMessage.vue?vue&type=style&index=1&id=7833792e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7833792e",
  null
  
)

export default component.exports